import React from 'react';
import ChangeTable from './ChangeTable';

const IntuneDocs = () => {
  return (
    <ChangeTable
      title="Recent Intune Documentation Changes"
      dataSource="intune-changes.json"
      showGuideLink={false}
    />
  );
};

export default IntuneDocs;